import React from "react";
import sociFondatori from "../../../assets/tenants/fsm/soci_fondatori.jpg";
import organigramma from "../../../assets/tenants/fsm/organigramma25-27.png";

export const FsmAboutUsPage: React.FC = () => {
  return (
    <div className="bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto space-y-12">
        <section className="md:text-center sm:text-left">
          <h1 className="text-3xl sm:text-4xl font-extrabold mb-4">
            Chi siamo
          </h1>
          <p className="text-gray-700">
            La Società Sportiva <span className="font-semibold">FSM</span> nasce
            il <strong>30 gennaio 2010</strong> da un gruppo di cinque amici con
            la voglia di creare uno spazio sociale e sportivo aperto a tutti.
          </p>
        </section>

        <section className="md:text-center sm:text-left">
          <h2 className="text-2xl font-bold mb-4 text-gray-800">
            I soci fondatori
          </h2>
          <p className="text-gray-600 mb-6">
            FSM e stata fondata da Andrea Bezzecchi, Massimiliano Lanzoni,
            Giordano Duo, Paolo Ricchetti e Gabriele Giberti.
          </p>
          <img
            src={sociFondatori}
            alt="Foto dei soci fondatori"
            className="rounded shadow-md mx-auto w-full max-w-lg"
          />
        </section>

        <section className="md:text-center sm:text-left">
          <h2 className="text-2xl font-bold mb-4 text-gray-800">
            La nostra filosofia
          </h2>
          <p className="text-gray-600 mb-2">
            Siamo un'associazione <strong>apolitica e senza scopo di lucro</strong>,
            nata per mettere al centro le <strong>persone</strong>.
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>Amicizia, inclusione e divertimento</li>
            <li>Solidarieta e integrazione sociale</li>
            <li>Crescita personale attraverso lo sport</li>
          </ul>
        </section>

        <section className="md:text-center sm:text-left">
          <h2 className="text-2xl font-bold mb-4 text-gray-800">Cosa facciamo</h2>
          <p className="text-gray-600 mb-4">
            Le attivita spaziano dal lato ludico a quello sportivo:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>
              <strong>Tornei ricreativi</strong>, gestiti anche tramite questo
              sito
            </li>
            <li>
              <strong>Attivita sportive</strong>: calcio a 7, pallavolo femminile
              e pallavolo mista
            </li>
          </ul>
        </section>

        <section className="md:text-center sm:text-left">
          <h2 className="text-2xl font-bold mb-4 text-gray-800">
            Il Consiglio Direttivo
          </h2>
          <ul className="space-y-1 text-gray-700">
            <li>
              <strong>Paolo Ricchetti</strong> - Presidente
            </li>
            <li>
              <strong>Giordano Duo</strong> - Vicepresidente
            </li>
            <li>
              <strong>Federica Mussini</strong> - Segretaria
            </li>
            <li>
              <strong>Maurizio Ferri</strong> - Consigliere
            </li>
            <li>
              <strong>Francesco La Macchia</strong> - Consigliere
            </li>
            <li>
              <strong>Gabriele Gorini</strong> - Consigliere
            </li>
          </ul>

          <div className="mt-6">
            <img
              src={organigramma}
              alt="Organigramma FSM"
              className="rounded shadow-md mx-auto w-full max-w-lg"
            />
          </div>
        </section>
      </div>
    </div>
  );
};
